import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { getSelectOptions } from '@panneau/core/utils';

var styles = {"container":"panneau-field-checkboxes-container","disabled":"panneau-field-checkboxes-disabled","btnCheck":"panneau-field-checkboxes-btnCheck"};

var propTypes = {
  name: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes$1.selectOptions,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps = {
  name: null,
  value: null,
  options: [],
  disabled: false,
  className: null,
  onChange: null
};
var Checkboxes = function Checkboxes(_ref) {
  var name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    disabled = _ref.disabled,
    className = _ref.className,
    _onChange = _ref.onChange;
  var finalOptions = useMemo(function () {
    return getSelectOptions(options);
  }, [options]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, 'btn-group', 'btn-group-toggle', _defineProperty(_defineProperty({}, styles.disabled, disabled), className, className !== null)]),
    "data-toggle": "buttons"
  }, finalOptions.map(function (_ref3) {
    var optionValue = _ref3.value,
      label = _ref3.label;
    return /*#__PURE__*/React.createElement("label", {
      key: "radio-".concat(optionValue),
      className: classNames(['btn', 'btn-outline-secondary', {
        active: value !== null && value.indexOf(optionValue) !== -1
      }])
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: classNames(['btn-check', styles.btnCheck]),
      name: "".concat(name, "[]"),
      autoComplete: "off",
      value: optionValue,
      disabled: disabled,
      onChange: function onChange(e) {
        var newValue = e.currentTarget.checked ? [].concat(_toConsumableArray(value), [optionValue]).filter(function (v) {
          return v !== null;
        }) : (value || []).filter(function (it) {
          return it !== optionValue;
        }) || null;
        if (_onChange !== null) {
          _onChange(newValue);
        }
      },
      checked: value !== null && value.indexOf(optionValue) !== -1
    }), label);
  }));
};
Checkboxes.propTypes = propTypes;
Checkboxes.defaultProps = defaultProps;

var definition = {
  id: 'checkboxes',
  component: 'Checkboxes'
};

export { Checkboxes as default, definition };
